import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 28px',
  },
  textSeperator: {
    padding: '0 8px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: {
    height: '6px',
    width: '6px',
    backgroundColor: '#9da1af',
    borderRadius: '50%',
  },
  dialogContent: {
    padding: '0',
  },
  spacing: {
    margin: '0 0 25px 0',
  },
  error: {
    margin: '5px 0 5px 0',
    fontSize: 20,
    color: '#D42F42',
  },
  wtnContainer: {
    padding: '20px 94px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f4f5f8',
  },
  avatar: {
    width: 64,
    height: 64,
    color: '#3e424e',
    backgroundColor: 'rgba(65, 143, 222, 0.2)',
    fontSize: '24px',
    marginRight: '20px',
  },
  separatorDot: {
    display: 'inline-block',
    width: '6px',
    height: '6px',
    backgroundColor: '#9da1af',
    borderRadius: '50%',
    transform: 'translateY(-35%)',
    margin: '0 12px',
  },
  tabContainer: {
    paddingLeft: '28px',
  },
  tabs: {
    '&': {
      backgroundColor: '#f4f5f8',
      paddingLeft: '28px',
    },
    '& button': {
      minWidth: '10px',
      width: '10px',
    },
    '.MuiTab-root': { minWidth: '46px', maxWidth: '46px' },
    '.MuiTab-root:first-of-type': { marginRight: '24px' },
  },

  listItemCont: {
    marginLeft: '40px',
    listStyleType: 'disc',
  },
  listItem: {
    display: 'list-item',
    paddingLeft: '8px',
  },
}));
